<template>
  <div class="box-border has-background-white h-100-per">
    <div class="mg-b-5 line-title-dh is-flex is-justify-spacebetween">
      <b-tooltip
        label="Move"
        v-if="user.userLevel == 0"
        type="is-dark"
        position="is-bottom"
      >
        <p
          class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
        >
          {{ $t("dashboard.mainDashboardBusinessGrowth") }}
        </p>
      </b-tooltip>
      <p
        v-else
        class="is-size-5 has-text-weight-normal pd-y-10 vue-draggable-handle"
      >
        {{ $t("dashboard.mainDashboardBusinessGrowth") }}
      </p>
      <p
        class="pd-y-10 icon-color is-size-5 cr-pointer"
        @click="$emit('openModalInfo', 'bn-g')"
      >
        <i class="fas fa-question-circle"></i>
      </p>
    </div>
    <b-tabs
      v-if="Object.keys(kpi).length > 0"
      v-model="activeTab"
      size="is-large"
      @change="$emit('changTap')"
    >
      <b-tab-item :visible="false"></b-tab-item>
      <b-tab-item
        class="pd-y-20"
        v-for="(value, index) in kpi"
        :key="index"
        :label="value.name"
      >
        <template slot="header">
          <div class="has-text-centered d-grid">
            <span v-if="$i18n.locale === 'th'" class="th">{{
              value.name
            }}</span>
            <span v-else>{{ getLabelNameChartEN(value.name) }}</span>

            <span class="is-size-5">
              <span
                v-if="value.value.length > 1 && Math.abs(value.percent) !== 0"
              >
                <span v-show="value.percent > 0">
                  <i class="fas fa-angle-up has-text-primary-green mg-t-5"></i>
                </span>
                <span v-show="value.percent < 0">
                  <i
                    class="fas fa-angle-down has-text-danger-status mg-t-5"
                  ></i>
                </span>
                <span
                  class="is-size-6 has-text-weight-semibold"
                  :class="
                    value.percent > 0
                      ? 'has-text-primary-green'
                      : ' has-text-danger-status'
                  "
                >
                  {{ Math.abs(value.percent) }}%
                </span>
              </span>
              <span class="is-size-6 has-text-weight-semibold"
                >({{ value.value[value.value.length - 1] | commaNumber }}
                <span v-if="$i18n.locale === 'th'" class="th">{{
                  value.name !== "การจ้างงาน(คน)" ? "บาท" : "คน"
                }}</span
                ><span v-else>{{
                  value.name !== "การจ้างงาน(คน)" ? "baht" : "people"
                }}</span
                >)</span
              >
            </span>
          </div>
        </template>
        <LineChart
          v-if="renderKpi === true"
          :height="350"
          :width="450"
          :bdColor="'#00a79d'"
          :labels="value.label"
          :lastUpdate="value.lastUpdate"
          :numData="value.value"
          :unitLabel="getLabelNameChartSuffix(value.name)"
          :commaY="true"
        />
      </b-tab-item>
    </b-tabs>
    <div
      v-else
      class="has-text-centered th is-size-5 pd-20 is-flex is-align-center is-justify-center h-100-per"
    >
      <p>*** {{ $t("dashboard.notfound") }} ***</p>
    </div>
  </div>
</template>

<script>
import LineChart from "../../charts/LineChart";
export default {
  props: ["kpi", "renderKpi"],
  components: {
    LineChart,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
    userDetail() {
      return this.$store.state.userDetail;
    },
  },
  data() {
    return {
      activeTab: 1,
    };
  },
  methods: {
    getLabelNameChartEN(text) {
      if (text === "รายได้(บาท)") {
        return `Revenue (baht)`;
      } else if (text === "การจ้างงาน(คน)") {
        return `Employment (people)`;
      } else {
        return `Investment (baht)`;
      }
    },
    getLabelNameChartSuffix(text) {
      if (text === "การจ้างงาน(คน)") {
        if (this.$i18n.locale === "th") {
          return `คน`;
        } else {
          return `people`;
        }
      } else {
        if (this.$i18n.locale === "th") {
          return `บาท`;
        } else {
          return `baht`;
        }
      }
    },
  },
};
</script>